import React, { Component } from 'react'

import classes from './EditModal.scss'

import moment from 'moment'
import { connect } from 'react-redux'

import {
  checkValidity,
  updateFormOptions,
  getNumericValue,
  getSelectvalue,
  updateObject
} from '../../../../helpers/utils'

import Spinner from '../../../../components/UI/Spinner/Spinner'
import Modal from '../../../../components/UI/Modal/Modal'
import Form from './Form/Form'
import { withTranslate } from 'react-redux-multilingual'
import { Chip } from '@material-ui/core'
import Footer from '../../../../components/UI/Modal/Footer/Footer'

class EditModal extends Component {
  state = {
    quantityForm: {
      item_code: {
        label: this.props.translate('appraisalItemCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('appraisalItemCode')
        },
        value: '',
        validation: {
          required: true,
          maxLength: 100
        },
        valid: false,
        touched: false,
        error: null
      },
      item_name: {
        label: this.props.translate('appraisalItemName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('appraisalItemName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      kpi_type_id: {
        label: this.props.translate('kpiType'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('kpiType'),
          options: []
        },
        value: '',
        validation: {},
        valid: false,
        touched: false,
        error: null
      },
      parent_item_id: {
        label: this.props.translate('kpiParent'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('kpiParent'),
          options: []
        },
        value: '',
        validation: {},
        valid: true,
        touched: false,
        error: null
      },
      uom_id: {
        label: this.props.translate('uom'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('uom'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      perspective_id: {
        label: this.props.translate('perspective'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('perspective'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      function_type_id: {
        label: this.props.translate('functionType'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('functionType'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      value_type_id: {
        label: this.props.translate('valueType'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('valueType'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      p_level: {
        label: this.props.translate('performanceLevel'),
        elementType: 'input',
        elementConfig: {
          multiline: true
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      general_desc: {
        label: this.props.translate('description'),
        elementType: 'textEditor',
        elementConfig: {
          placeholder: this.props.translate('description')
        },
        value: '',
        validation: {},
        valid: true,
        touched: false,
        error: null
      },
      // formula: {
      //   label: this.props.translate('formula'),
      //   elementType: 'formula',
      //   formulaSelectValue: '',
      //   value: '',
      //   elementConfig: {
      //     options: [],
      //     placeholder: this.props.translate('select') + this.props.translate('kpi')
      //   },
      //   validation: {},
      //   valid: true,
      //   touched: false,
      //   error: null
      // },
      // formula_desc: {
      //   label: this.props.translate('formulaDescription'),
      //   elementType: 'input',
      //   elementConfig: {
      //     placeholder: this.props.translate('formulaDescription')
      //   },
      //   value: '',
      //   validation: {},
      //   valid: true,
      //   touched: false,
      //   error: null
      // },
      is_show_variance: {
        label: this.props.translate('isShowVariance'),
        elementType: 'checkbox',
        elementConfig: {},
        value: false,
        validation: {},
        valid: true,
        touched: false,
        error: null
      },
      is_prorate: {
        label: this.props.translate('prorate'),
        elementType: 'checkbox',
        elementConfig: {},
        value: false,
        validation: {},
        valid: true,
        touched: false,
        error: null
      },
      is_sum_up: {
        label: this.props.translate('sumUp'),
        elementType: 'checkbox',
        elementConfig: {},
        value: false,
        validation: {},
        valid: true,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {},
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    qualityForm: {
      item_code: {
        label: this.props.translate('appraisalItemCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('appraisalItemCode')
        },
        value: '',
        validation: {
          required: true,
          maxLength: 100
        },
        valid: false,
        touched: false,
        error: null
      },
      item_name: {
        label: this.props.translate('appraisalItemName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('appraisalItemName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      competency_type_id: {
        label: this.props.translate('competencyType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('competencyType'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      p_level: {
        label: this.props.translate('proficiencyLevel'),
        elementType: 'input',
        elementConfig: {
          multiline: true
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {},
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    deductForm: {
      item_name: {
        label: this.props.translate('deductName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('deductName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      max_value: {
        label: this.props.translate('maxValue'),
        elementType: 'input',
        elementConfig: {
          type: 'number',
          placeholder: this.props.translate('maxValue')
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true
        },
        valid: false,
        touched: false,
        error: null
      },
      unit_deduct_score: {
        label: this.props.translate('deductScoreUnit'),
        elementType: 'input',
        elementConfig: {
          type: 'number',
          placeholder: this.props.translate('deductScoreUnit')
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true
        },
        valid: false,
        touched: false,
        error: null
      },
      value_get_zero: {
        label: this.props.translate('valueGetZero'),
        elementType: 'input',
        elementConfig: {
          type: 'number',
          placeholder: this.props.translate('valueGetZero')
        },
        value: '',
        validation: {
          required: !!this.props.isValueGetZero,
          isNumeric: true,
          min: 0
        },
        valid: !this.props.isValueGetZero,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {},
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    qualityWithTagForm: {
      item_code: {
        label: this.props.translate('appraisalItemCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('appraisalItemCode')
        },
        value: '',
        validation: {
          required: true,
          maxLength: 100
        },
        valid: false,
        touched: false,
        error: null
      },
      item_name: {
        label: this.props.translate('appraisalItemName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('appraisalItemName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      competency_type_id: {
        label: this.props.translate('competencyType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('competencyType'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      tags: {
        label: this.props.translate('tag'),
        elementType: 'newmultiSelect',
        elementConfig: {
          options: [],
          freeSolo: true,
          renderTags: (value, getTagProps) =>
            value.map((option, index) => <Chip label={option} {...getTagProps({ index })} />)
        },
        value: [],
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      competency_max: {
        label: this.props.translate('competencyMax'),
        elementType: 'input',
        elementConfig: { type: 'number' },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      p_level: {
        label: this.props.translate('proficiencyLevel'),
        elementType: 'input',
        elementConfig: {
          multiline: true
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {},
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    formMapper: {
      STT01: 'quantity',
      STT02: 'quality',
      STT03: 'deduct',
      STT04: 'quantity',
      STT05: 'qualityWithTag',
      STT06: 'quality'
    },
    formIsValid: false,
    addAno: false,
    // store props as state for re-rendering comparison check
    selectedRecord: this.props.selectedRecord,
    kpiTypeOptions: this.props.kpiTypeOptions,
    parentKpiOptions: this.props.parentKpiOptions,
    uomOptions: this.props.uomOptions,
    perspectiveOptions: this.props.perspectiveOptions,
    valueTypeOptions: this.props.valueTypeOptions,
    functionTypeOptions: this.props.functionTypeOptions,
    competencyTypeOptions: this.props.competencyTypeOptions,
    companyOptions: this.props.companyOptions,
    tagOptions: this.props.tagOptions
  }

  static getDerivedStateFromProps(props, state) {
    // Check if modal is open without selecting structure (this case might not exist but we better beware)
    let structureType = null
    if (props.structure) {
      structureType = state.formMapper[props.structure] + 'Form'
    }

    if (props.kpiTypeOptions !== state.kpiTypeOptions) {
      let updatedForms = ['quantityForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.kpi_type_id
        let updatedFormItem = updateFormOptions(
          props.kpiTypeOptions,
          targetFormItem,
          'kpi_type_id',
          'kpi_type_id',
          'kpi_type_name',
          'Select KPI Type'
        )

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { kpi_type_id: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        kpiTypeOptions: props.kpiTypeOptions
      }
    }

    if (props.parentKpiOptions !== state.parentKpiOptions) {
      let updatedForms = ['quantityForm'].reduce((updatedForms, formName) => {
        let inputForms = state[formName]
        let targetFormItem = null
        let updatedFormItem = null
        let updatedForm = { ...inputForms }
        if (formName === 'quantityForm') {
          targetFormItem = inputForms.parent_item_id
          updatedFormItem = updateFormOptions(
            props.parentKpiOptions,
            targetFormItem,
            'item_id',
            'item_id',
            { code: 'item_code', name: 'item_name' },
            'Select Parent KPI'
          )

          updatedForm = updateObject(updatedForm, { parent_item_id: updatedFormItem })
        }

        // targetFormItem = inputForms.formula
        // updatedFormItem = updateFormOptions(
        //   props.parentKpiOptions,
        //   targetFormItem,
        //   'item_id',
        //   'item_code',
        //   'item_name',
        //   'Select KPI'
        // )

        // updatedForm = { ...updatedForm, formula: updatedFormItem }

        return { ...updatedForms, [formName]: updatedForm }
      }, {})

      return {
        ...updatedForms,
        parentKpiOptions: props.parentKpiOptions
      }
    }

    if (props.uomOptions !== state.uomOptions) {
      let updatedForms = ['quantityForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.uom_id
        let updatedFormItem = updateFormOptions(
          props.uomOptions,
          targetFormItem,
          'uom_id',
          'uom_id',
          'uom_name',
          'Select UOM'
        )

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { uom_id: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        uomOptions: props.uomOptions
      }
    }

    if (props.perspectiveOptions !== state.perspectiveOptions) {
      let updatedForms = ['quantityForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.perspective_id
        let updatedFormItem = updateFormOptions(
          props.perspectiveOptions,
          targetFormItem,
          'perspective_id',
          'perspective_id',
          'perspective_name',
          'Select Perspective'
        )

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { perspective_id: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        perspectiveOptions: props.perspectiveOptions
      }
    }

    if (props.valueTypeOptions !== state.valueTypeOptions) {
      let updatedForms = ['quantityForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.value_type_id
        let updatedFormItem = updateFormOptions(
          props.valueTypeOptions,
          targetFormItem,
          'value_list_id',
          'value_list_id',
          'value_list_name',
          'Select Value Type'
        )

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { value_type_id: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        valueTypeOptions: props.valueTypeOptions
      }
    }

    if (props.functionTypeOptions !== state.functionTypeOptions) {
      let updatedForms = ['quantityForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.function_type_id
        let updatedFormItem = updateFormOptions(
          props.functionTypeOptions,
          targetFormItem,
          'value_list_id',
          'value_list_id',
          'value_list_name',
          'Select Value Type'
        )

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { function_type_id: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        functionTypeOptions: props.functionTypeOptions
      }
    }

    if (props.competencyTypeOptions !== state.competencyTypeOptions) {
      let updatedForms = ['qualityForm', 'qualityWithTagForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.competency_type_id
        let updatedFormItem = updateFormOptions(
          props.competencyTypeOptions,
          targetFormItem,
          'value_list_id',
          'value_list_id',
          'value_list_name',
          'Select Value Type'
        )

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { competency_type_id: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        competencyTypeOptions: props.competencyTypeOptions
      }
    }

    if (props.tagOptions !== state.tagOptions) {
      let updatedForms = ['qualityWithTagForm'].reduce((updatedForm, formName) => {
        let inputForms = state[formName]
        let targetFormItem = inputForms.tags
        let updatedFormItem = {
          ...targetFormItem,
          elementConfig: { ...targetFormItem.elementConfig, options: props.tagOptions }
        }

        return {
          ...updatedForm,
          [formName]: updateObject(state[formName], { tags: updatedFormItem })
        }
      }, {})
      return {
        ...updatedForms,
        tagOptions: props.tagOptions
      }
    }

    // Set form value for edit
    if (props.selectedRecord !== state.selectedRecord) {
      let newInputGroupState = Object.entries(state[structureType]).reduce((formGroups, form) => {
        let [formKey, formAttrs] = form

        let value = ''

        let valid = !formAttrs.validation.required
        let touched = false
        let errorMessage = null

        if (props.selectedRecord) {
          if (formAttrs.elementType === 'datePicker') {
            value = props.selectedRecord[formKey] || null
          } else if (formAttrs.elementType === 'checkbox') {
            value = !!props.selectedRecord[formKey]
          } else if (formAttrs.elementType === 'newselect') {
            value =
              getSelectvalue(
                props.selectedRecord[formKey],
                state[structureType][formKey]?.elementConfig?.options
              ) || null
            // } else if (formAttrs.elementType === 'newmultiSelect') {
            //   value = props.selectedRecord[formKey]
          } else {
            value = props.selectedRecord[formKey]
          }

          let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)

          valid = isValid
          errorMessage = error
        } else if (!props.selectedRecord) {
          if (formAttrs.elementType === 'datePicker') {
            value = null
          } else if (formAttrs.elementType === 'checkbox') {
            if (formKey === 'is_active') {
              value = true
            } else {
              value = false
            }
          }
        }

        const newFormAttrs = {
          ...formAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
      }, {})

      let formIsValid = true

      Object.entries(newInputGroupState).map(form => {
        let [, formAttrs] = form
        return (formIsValid = formIsValid && formAttrs.valid)
      })

      return {
        [structureType]: newInputGroupState,
        selectedRecord: props.selectedRecord,
        formIsValid: formIsValid
      }
    }

    return null
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success && this.props.success) {
      this.clearForm()
    }
  }

  inputChangeHandler = (formStructure, formKey, event) => {
    formStructure = `${formStructure}Form`
    const formItem = this.state[formStructure][formKey]

    let inputValue = ''

    if (formItem.elementType === 'checkbox') {
      inputValue = event.target.checked
    } else if (
      ['newselect', 'newmultiSelect', 'textEditor', 'datePicker', 'formula'].includes(
        formItem.elementType
      )
    ) {
      inputValue = event

      // if (formKey === 'tags') {
      //   if (inputValue?.length) {
      //     inputValue = inputValue.map(item => {
      //       if (typeof item === 'object') {
      //         return item
      //       }
      //       return { key: Math.random() * 100, value: 'new', label: item }
      //     })
      //   }
      // }
    } else {
      inputValue = event.target.value
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updatedForm = updateObject(this.state[formStructure], {
      [formKey]: updatedFormItem
    })

    let formIsValid = true

    Object.entries(updatedForm).map(form => {
      let [, formAttrs] = form
      return (formIsValid = formIsValid && formAttrs.valid)
    })

    this.setState({
      [formStructure]: updatedForm,
      formIsValid: formIsValid
    })
  }

  clearForm = () => {
    if (this.props.action === 'delete' || !this.props.structure) return
    const formName = `${this.state.formMapper[this.props.structure]}Form`
    let form = { ...this.state[formName] }

    Object.entries(form).forEach(formItem => {
      let [formKey, formAttr] = formItem
      let value = ''
      let valid = true

      if (['datePicker', 'newselect'].includes(formAttr.elementType)) {
        value = null
      }

      if (formAttr.elementType === 'checkbox') {
        value = false
      }

      if (formAttr.validation.required) {
        valid = false
      }

      if (formAttr.elementType === 'formula') {
        value = ''
      }

      if (formAttr.elementType === 'newmultiSelect') {
        value = []
      }

      form[formKey] = { ...formAttr, value: value, valid: valid, touched: false }
    })
    if (!this.state.addAno) {
      this.props.onHide()
    } else {
      this.setState({
        addAno: false
      })
    }
    this.setState({
      [formName]: form,
      formIsValid: false
    })
  }

  modalCloseHandler = () => {
    if (this.props.action === 'edit') {
      this.clearForm()
    }
    this.props.onHide()
  }

  formSubmitHandler = type => {
    let structureType = null
    if (this.props.structure) {
      structureType = this.state.formMapper[this.props.structure] + 'Form'
    }

    let formData = Object.entries(this.state[structureType]).reduce((formData, formEntry) => {
      let [formKey, formAttrs] = formEntry

      let value = ''
      if (formAttrs.elementType === 'datePicker') {
        value = moment(formAttrs.value).format('YYYY-MM-DD')
      } else if (formAttrs.elementType === 'newselect') {
        value = formAttrs?.value?.value
      } else {
        value = formAttrs.value
      }

      if (formAttrs.validation.isNumeric) {
        value = getNumericValue(value)
      }

      return { ...formData, [formKey]: value }
    }, {})
    this.setState({
      addAno: type === 'saveAno'
    })
    this.props.onSave({ ...this.props.selectedRecord, ...formData }, type === 'saveAno')
  }

  formulaSelectChangeHandler = (structureKey, formKey, value) => {
    structureKey = `${structureKey}Form`
    this.setState({
      ...this.state,
      [structureKey]: {
        ...this.state[structureKey],
        [formKey]: {
          ...this.state[structureKey][formKey],
          formulaSelectValue: value
        }
      }
    })
  }

  render() {
    const { loading, structure, action, open } = this.props
    const {
      formIsValid,
      quantityForm,
      qualityForm,
      deductForm,
      qualityWithTagForm,
      formMapper
    } = this.state

    const structureType = structure ? formMapper[structure] : null

    let formDisplay = <Spinner />
    let form = {}
    let formGroup = null

    switch (structureType) {
      case 'quantity':
        form = quantityForm
        break
      case 'quality':
        form = qualityForm
        break
      case 'deduct':
        form = deductForm
        break
      case 'qualityWithTag':
        form = qualityWithTagForm
        break
      default:
        form = {}
        break
    }

    formGroup = (
      <Form
        form={form}
        inputChanged={(formKey, e) => this.inputChangeHandler(structureType, formKey, e)}
        formulaSelectChanged={(formKey, value) =>
          this.formulaSelectChangeHandler(structureType, formKey, value)
        }
        isValueGetZero={this.props.isValueGetZero}
      />
    )

    if (!loading) {
      formDisplay = formGroup
    }
    let footer = (
      <Footer
        save={() => this.formSubmitHandler('save')}
        another={() => this.formSubmitHandler('saveAno')}
        showAnother={this.props.action === 'add'}
        cancel={() => this.clearForm()}
        disable={!formIsValid}
      />
    )
    return (
      <Modal
        open={open}
        onHide={this.modalCloseHandler}
        header={this.props.translate(action) + this.props.translate('appraisalItem')}
        backdropClicked={this.modalCloseHandler}
        footer={footer}>
        <div className={classes.ModalBody}>{formDisplay}</div>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    selectedRecord: state.appraisalItems.selectedRecord,
    kpiTypeOptions: state.appraisalItems.kpiTypes,
    parentKpiOptions: state.appraisalItems.parentKpis,
    uomOptions: state.appraisalItems.uoms,
    perspectiveOptions: state.appraisalItems.perspectives,
    valueTypeOptions: state.appraisalItems.valueTypes,
    functionTypeOptions: state.appraisalItems.functionTypes,
    competencyTypeOptions: state.appraisalItems.competencyTypes,
    companyOptions: state.appraisalItems.companies,
    tagOptions: state.appraisalItems.tags,
    loading: state.appraisalItems.modalLoading || state.appraisalItems.selectedRecordLoading,
    success: state.appraisalItems.saved
  }
}

export default connect(mapStateToProps)(withTranslate(EditModal))
